import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RtLinkDirective } from './directives/rt-link.directive';

@NgModule({
  declarations: [RtLinkDirective],
  imports: [CommonModule],
  exports: [RtLinkDirective],
})
export class RtLinkModule {}
